import type { ActiveRunSummary, RunDetail } from "../../api/types.js";

export function ActiveRunNotice({
  run,
  currentSessionOwnsRun,
  onReturn
}: {
  run: ActiveRunSummary | RunDetail;
  currentSessionOwnsRun: boolean;
  onReturn: () => void;
}) {
  const phase = "phase" in run ? run.phase : run.status;
  if (!currentSessionOwnsRun) {
    const title = "sessionTitle" in run ? run.sessionTitle : "";
    return (
      <div className="active-run-notice" data-active-run-notice role="status">
        <div className="active-run-notice-copy">
          <p className="active-run-notice-title">“{title}”正在处理中</p>
          <p>当前暂时不能发送新问题</p>
        </div>
        <button type="button" className="active-run-return" onClick={onReturn}>返回正在处理的对话</button>
      </div>
    );
  }
  const body = phase === "running"
    ? "正在继续处理，完成后会自动显示回答"
    : phase === "cancelling"
      ? "正在停止，并保存已生成内容"
      : "回答已经生成，正在保存结果";
  return (
    <div className="active-run-notice" data-active-run-notice role="status">
      <div className="active-run-notice-copy">
        <p>{body}</p>
      </div>
    </div>
  );
}
